import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-email-logo-icon',
  templateUrl: './email-logo-icon.component.html',
  styles: []
})
export class EmailLogoIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
